import { autoGeneratedReducer, makeSetStoreField } from '@hh.ru/redux-create-reducer';

export const isGeoSwitcherActive = autoGeneratedReducer<boolean>(false);
export const setIsGeoSwitcherActive = makeSetStoreField('isGeoSwitcherActive');
